import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UntilDestroy } from "@ngneat/until-destroy";
import { Section } from "pax-ui/components";
import { Emoji } from "projects/pax-ui/components/emoji/emoji-alt-mapping";
import { ProductSpecificCustomRouteData } from "src/app/shared/routes/shared/shared-route.constant";
import { RouteDataService } from "src/app/shared/services/route-data.service";
import { ContactSupportComponent } from "../../components/contact-support/contact-support";

@UntilDestroy()
@Component({
  selector: "app-application-digital-signature-error",
  imports: [Section, CommonModule, ContactSupportComponent],
  templateUrl: "./digital-signature-error.page.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DigitalSignatureErrorPage {
  readonly emojis: Emoji[] = ["🦸"];
  readonly productSpecificCustomRouteData: ProductSpecificCustomRouteData;

  constructor(
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _routeDataService: RouteDataService,
  ) {
    this.productSpecificCustomRouteData =
      this._routeDataService.getProductSpecificCustomRouteData(
        this._activatedRoute,
      );
  }
}
